if (!document.getElementById('root')) {
    require('./index_old.js');
} else {
    require('./index_new');
}

